<ion-content>
  <ion-refresher slot="fixed" (ionRefresh)="buscarDetalhesPagamento($event)">
    <ion-refresher-content>
    </ion-refresher-content>
  </ion-refresher>

  <usucampeao-pagamentos-detalhes [pagamento]="pagamento$ | async" (aoVisualizarBoleto)="abrirBoleto()"></usucampeao-pagamentos-detalhes>
</ion-content>
